module.exports = __webpack_public_path__ + "img/acompanhante-vip.57a27047.png";